import React, { useEffect, useState, useRef } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Button, Modal, Typography, Table, Spin, message, Space, Tooltip, Popconfirm, Tag, Input, Form, Select } from 'antd';
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined, SearchOutlined, FilterOutlined, ClearOutlined, AppstoreOutlined } from '@ant-design/icons';
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL, APPBACKGROUND_COLOR } from '../../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../../usableclasses.js';
import Highlighter from 'react-highlight-words';

import { Link } from 'react-router-dom';
const { Content } = Layout;
const { Title, Text } = Typography;

function ProductManagement() {

    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG } } = theme.useToken();

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleting, setDeleting] = useState(false);
    // Add state for filter values and filter options
    const [filterValues, setFilterValues] = useState({
        proKeyword: "",
        proUseAs: "",
        proBrandId: "",
        proCategoryId: "",
        proDevelopmentId: "",
        proPositionId: "",
        proSalesEnable: ""
    });
    const [filterForm] = Form.useForm();
    const [categories, setCategories] = useState([]);
    const [brands, setBrands] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [positions, setPositions] = useState([])
    const navigate = useNavigate();

    useEffect(() => {
        fetchProducts();
        fetchFilterOptions();
    }, []);

    const fetchFilterOptions = async () => {
        try {
            const headers = { SystemAccessToken: TOKEN };

            const [categoriesRes, brandsRes, productTypesRes, posintionRes] = await Promise.all([
                axios.get(`${ApiURL}/master/category/all`, { headers }),
                axios.get(`${ApiURL}/master/brands/all`, { headers }),
                axios.get(`${ApiURL}/master/productstype/dropdown`, { headers }),
                axios.get(`${ApiURL}/master/position/dropdown`, { headers }),
            ]);

            if (categoriesRes.data && Array.isArray(categoriesRes.data)) {
                setCategories(categoriesRes.data);
            }

            if (brandsRes.data && Array.isArray(brandsRes.data)) {
                setBrands(brandsRes.data);
            }

            if (productTypesRes.data && Array.isArray(productTypesRes.data)) {
                setProductTypes(productTypesRes.data);
            }

            if (posintionRes.data && Array.isArray(posintionRes.data)) {
                setPositions(posintionRes.data);
            }

        } catch (error) {
            AlertError("Failed to load filter options");
        }
    };

    const handleFilter = () => {
        const values = filterForm.getFieldsValue();
        setFilterValues(values);
        fetchProducts(values);
    };

    const handleClearFilters = () => {
        filterForm.resetFields();
        const emptyFilters = {
            proKeyword: "",
            proUseAs: "",
            proBrandId: "",
            proCategoryId: "",
            proDevelopmentId: "",
            proPositionId: "",
            proSalesEnable: ""
        };
        setFilterValues(emptyFilters);
        fetchProducts(emptyFilters);
    };

    const fetchProducts = async (filters = filterValues) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };

            const response = await axios.post(`${ApiURL}/products/all`, filters, { headers });

            if (response.data && Array.isArray(response.data)) {

                //const productsWithNames = await enrichProductData(response.data);

                setProducts(response.data);

            } else {
                setProducts([]);

            }
        } catch (error) {

            AlertError("Failed to fetch products.");
        } finally {
            setLoading(false);
        }
    };


    const confirmDeleteProduct = (productId) => {
        Modal.confirm({
            title: "Are you sure you want to delete this product?",
            icon: <ExclamationCircleOutlined />,
            content: "This action cannot be undone.",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: () => deleteProduct(productId),
        });
    };

    const deleteProduct = async (productId) => {
        setDeleting(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/products/delete/${productId}`, { headers });

            if (response.status === 200) {
                AlertSuccess("Product deleted successfully.");
                fetchProducts();
            }
        } catch (error) {
            AlertError("Failed to delete product.");
        } finally {
            setDeleting(false);
        }
    };

    const handleProductAttribute = (productId) => {
        if (!productId) {
            AlertError("Invalid product ID. Cannot edit this product.");
            return;
        }
        navigate(`/master/productlist/attributes/${productId}`);
    }


    const handleEditProduct = (productId) => {
        if (!productId) {
            AlertError("Invalid product ID. Cannot edit this product.");
            return;
        }
        navigate(`/master/productupdate/${productId}`);
    };

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex, closeDropdown = true) => {
        confirm({ closeDropdown });
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters, confirm, dataIndex, closeDropdown = true) => {
        clearFilters();
        if (confirm) {
            confirm({ closeDropdown });
        }
        setSearchText('');
        if (dataIndex === searchedColumn) {
            setSearchedColumn('');
        }
    };

    const getColumnSearchProps = (dataIndex, title) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => handleReset(clearFilters, confirm, dataIndex)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({ closeDropdown: false });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                </Space>
            </div>
        ),
        // filterIcon: filtered => ( // Removed as per request
        //     <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        // ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: "Actions",
            key: "actions",
            fixed: "left",
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button
                            type="link"
                            icon={<EditOutlined />}
                            onClick={() => handleEditProduct(record.proId)}
                            disabled={loading || deleting}
                        />
                    </Tooltip>
                    <Tooltip title="Attribute">
                        <Button
                            type="link"
                            icon={<AppstoreOutlined style={{ color: 'purple' }} />}
                            onClick={() => handleProductAttribute(record.proId)}
                            disabled={loading || deleting}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this product?"
                        onConfirm={() => deleteProduct(record.proId)}
                        okText="Yes"
                        cancelText="No"
                        disabled={loading || deleting}
                    >
                        <Tooltip title="Delete">
                            <Button
                                type="link"
                                danger
                                icon={<DeleteOutlined />}
                                disabled={loading || deleting}
                            />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: "SKU",
            dataIndex: "proSku",
            key: "proSku",
        },
        {
            title: "Name",
            dataIndex: "proName",
            key: "proName",
        },
        {
            title: "Use As",
            dataIndex: "proUseAs",
            key: "proUseAs",
        },
        {
            title: "Brand",
            dataIndex: "brandName",
            key: "brandName",
        },
        {
            title: "Category",
            dataIndex: "catName",
            key: "catName",
        },
        {
            title: "Development",
            dataIndex: "development",
            key: "development",
        },
        {
            title: "UOM",
            dataIndex: "uom",
            key: "uom",
        },
        {
            title: "Size",
            dataIndex: "proSize",
            key: "proSize",
        },
        {
            title: "Offer Price",
            dataIndex: "proOfferMrp",
            key: "proOfferMrp",
            render: (price) => `${parseFloat(price || 0).toFixed(2)}`
        },
        {
            title: "On Sale",
            dataIndex: "proIsSale",
            key: "proIsSale",
            render: (isSale) => isSale ? "Yes" : "No",
        },
        {
            title: "Status",
            dataIndex: "proIsActive",
            key: "proIsActive",
            render: (status) => (
                <Tag color={status === true ? "green" : "red"}>
                    {status === true ? "Active" : "Inactive"}
                </Tag>
            ),
        },
    ];

    const reCalculateParameters = async () => {
        try {
            setLoading(true)
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/products/pricelistcalrevalidate`, { headers });
            AlertSuccess("Price List Recalculated Successfully!");
        } catch (error) {
            AlertError("Failed to recalculate parameters.");
        } finally {
            setLoading(false)
        }
    }

    return (
        <Spin spinning={loading || deleting} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
                <Headerdiv />
                <Content style={{ padding: '10px' }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item>Master</Breadcrumb.Item> {/* No direct /master route */}
                        <Breadcrumb.Item><Link to="/master/productlist">Products</Link></Breadcrumb.Item>
                    </Breadcrumb>
                    <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
                        <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>
                            <Row>
                                <Col xs={24} style={{ textAlign: "right", marginBottom: '20px' }}>
                                    <Space>
                                        <Button type="primary" onClick={() => reCalculateParameters()}>Parameter Recalculate</Button>
                                        <Button type="primary" onClick={() => navigate("/master/productexcelupload")}>Price List Update</Button>
                                        <Button type="primary" onClick={() => navigate("/master/productcreate")}>Create New</Button>
                                    </Space>
                                </Col>
                            </Row>

                            <div className="filter-container" style={{ marginBottom: '20px' }}>
                                <Typography.Title level={5}>Filter Products</Typography.Title>
                                <Form
                                    form={filterForm}
                                    layout="vertical"
                                    initialValues={filterValues}
                                >
                                    <Row gutter={[16, 16]}>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proKeyword"
                                                label="Search Keyword"
                                            >
                                                <Input placeholder="SKU, Name, etc." />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proUseAs"
                                                label="Use As"
                                            >
                                                <Select
                                                    placeholder="Select use type"
                                                    allowClear
                                                    options={[
                                                        { value: "NORMAL", label: "Normal" },
                                                        { value: "COMBO", label: "Combo" }
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proBrandId"
                                                label="Brand"
                                            >
                                                <Select
                                                    placeholder="Select brand"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={brands.map(brand => ({
                                                        value: brand.brandId.toString(),
                                                        label: brand.brandName
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proCategoryId"
                                                label="Category"
                                            >
                                                <Select
                                                    placeholder="Select category"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={categories.map(cat => ({
                                                        value: cat.categoryId,
                                                        label: cat.categoryName
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proTypeId"
                                                label="Product Type"
                                            >
                                                <Select
                                                    placeholder="Select product type"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={productTypes.map(type => ({
                                                        value: type.id,
                                                        label: type.label
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proDevelopmentId"
                                                label="Development"
                                            >
                                                <Select
                                                    placeholder="Select Development"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={[{ label: "LOCAL" }, { label: "INT" }].map(ps => ({
                                                        value: ps.label,
                                                        label: ps.label
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proPositionId"
                                                label="Position"
                                            >
                                                <Select
                                                    placeholder="Select Position"
                                                    allowClear
                                                    showSearch
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                    }
                                                    options={positions.map(ps => ({
                                                        value: ps.id,
                                                        label: ps.label
                                                    }))}
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} sm={8} md={4}>
                                            <Form.Item
                                                name="proSalesEnable"
                                                label="Sales Enabled"
                                            >
                                                <Select
                                                    placeholder="Select status"
                                                    allowClear
                                                    options={[
                                                        { value: "yes", label: "Yes" },
                                                        { value: "no", label: "No" }
                                                    ]}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Space>
                                                <Button
                                                    type="primary"
                                                    icon={<FilterOutlined />}
                                                    onClick={handleFilter}
                                                >
                                                    Apply Filters
                                                </Button>
                                                <Button
                                                    icon={<ClearOutlined />}
                                                    onClick={handleClearFilters}
                                                >
                                                    Clear Filters
                                                </Button>
                                            </Space>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>

                            <Typography.Title level={5}>List of Products</Typography.Title>
                            <Table
                                columns={columns}
                                dataSource={products}
                                rowKey="proId"
                                pagination={{ pageSize: 10 }}
                                scroll={{ x: 1500 }}
                            />
                        </Space>
                    </div>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
}

export default ProductManagement;
